import type {SubscriptionState} from './subscriptionTypes';

/**
 * Three flags that ALL need to be false before we can open another socket.
 * Used by `scheduleReconnect` and indirectly by every code path that decides
 * whether to keep the self-heal loop running.
 */
export const canReconnect = (state: SubscriptionState) =>
  !state.isCleaningUp && !state.hasStopped && !state.isRefreshing;
